<template>
  <div v-if="order">
    <div class="elevation-1 rounded pa-5 white" :class="inquiry.status == 0 ? 'greeny--border' : 'primary--border'">
      <v-row class="align-center">
        <v-col md="auto">
          <h3>
            <span class="primary--text">Status : </span>
            {{ getStatusText(lastEvent(inquiry.events[0]).code) }}
          </h3>
          <div class="text-caption mt-1 font-weight-bold">
            Inquiry Created
            <code class="text-caption">{{ inquiry.created | getOnlyDate }} {{ inquiry.created | getOnlyTime }}</code>
            (GMT+{{ getGmtDiff }}) by
            <code class="text-caption greeny white--text">{{ origin }}</code>
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col md="auto">
          <div class="d-flex align-center justify-end">
            <h3 class="secondary--text">
              {{ order.id }}
            </h3>
            <OrderIconsField
              :order="order"
              :showPrintableInfo="true"
              :showDistributedInfo="true"
              :showGroupOrderInfo="true"
              :showClaimInfo="false"
              :showArchiveOrder="true"></OrderIconsField>
            <v-btn @click="navOrder(order.id)" class="ml-2" small color="accent">Order Detail </v-btn>
          </div>

          <div class="caption secondary--text mt-1 font-weight-bold">
            Order Created
            <code class="text-caption">{{ order.created | getOnlyDate }} {{ order.created | getOnlyTime }}</code>
            (GMT+{{ getGmtDiff }}) by
            <code class="text-caption greeny white--text">
              {{ order.seller.user.fullName ?? order.seller.user.name }}</code
            >
          </div>
        </v-col>
      </v-row>
    </div>

    <external-booking-summary :bookings="order.bookings" :tenant-name="order.seller.tenant.name" />
  </div>
</template>

<script>
import moment from "moment";
import OrderIDField from "@/components/common/OrderIDField";
import { copyToClipboard, fixUrl } from "@/util/helpers";
import toolbarTitle from "@/components/common/toolbarTitle";
import OrderIconsField from "@/components/common/OrderIconsField";
import common from "@/mixins/common";
import ExternalBookingSummary from "@/components/info/externalBookingSummary.vue";
import { eventStatus } from "@/globals";

export default {
  components: {
    ExternalBookingSummary,
    OrderIconsField,
    toolbarTitle,
    copyToClipboard,
    OrderIDField,
  },
  computed: {
    getGmtDiff() {
      return moment().utcOffset() / 60;
    },
  },
  mixins: [common],
  data: () => ({
    order: null,
    origin: null,
  }),
  filters: {
    humanDatetime(datetime) {
      return moment.utc(datetime).local().fromNow();
    },
    getOnlyDate(datetime) {
      return moment.utc(datetime).format("YYYY-MM-DD");
    },
    getOnlyTime(datetime) {
      return moment.utc(datetime).local().format("HH:mm");
    },
  },
  mounted() {
    this.order = this.inquiry.orders[0];
    let firstEvent = this.inquiry.events[0];
    if (firstEvent) {
      this.origin = firstEvent.user.fullName ?? firstEvent.user.name;
    }
  },
  methods: {
    copyToClipboard,
    fixUrl,
    navOrder(value) {
      window.open("/orders/" + value);
    },

    lastEvent(event) {
      return {
        message: event ? event.message : null,
        user: event ? event.user.fullName ?? event.user.name : null,
        code: event ? event.code : null,
      };
    },

    getStatusText(code) {
      if (!code) return code;
      const result = eventStatus.find((event) => event.value === code);
      if (result) return result.label;
      return code
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/^./, (c) => c.toUpperCase());
    },
  },
  props: {
    inquiry: [],
  },
};
</script>

<style lang="scss" scoped>
.greeny--border {
  border-bottom: 5px solid #86c589 !important;
}

.primary--border {
  border-bottom: 5px solid #f37a62 !important;
}
</style>
